import { ReactElement } from 'react';
import { BaseIcon, BaseIconProps } from '../BaseIcon';

export const RemoveIcon = ({ ...props }: Omit<BaseIconProps, 'children'>): ReactElement => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12.001C4 11.4487 4.44772 11.001 5 11.001H19C19.5523 11.001 20 11.4487 20 12.001C20 12.5533 19.5523 13.001 19 13.001H5C4.44772 13.001 4 12.5533 4 12.001Z"
    />
  </BaseIcon>
);

RemoveIcon.displayName = 'RemoveIcon';
